/*
 * @Author: pengchunyan pengchunyan@kw13.cn
 * @Date: 2023-06-02 14:49:22
 * @LastEditors: pengchunyan pengchunyan@kw13.cn
 * @LastEditTime: 2023-06-02 14:51:34
 * @FilePath: /doctor2/store/userInfo/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  namespaced: true,
  state() {
    return {
      skills: [],
      doctorPracticingPic: [],
      professionalQualificationPic: [],
      doctorQualificationPic: [],
      idCardPic: [],
      signaturePic: '', //手写签名
      regionInfo: null,
      hospitalInfo: null,
      baseInfo: null, //存放基本信息
      isFirstVerify: false, // 是否第一次认证:true: 第一次认证；false：修改认证
      appUploadedImg: null, // app接口返回的图片的路径和类型 {type: "" , urls:[]}
      pageFrom: '', // 从哪个页面返回
      userInfoForm: '' //认证页提交数据
    }
  },
  getters: {},
  mutations: {
    setSkills(state, newSkills) {
      state.skills = newSkills
    },
    setDoctorPracticingPic(state, newVal) {
      state.doctorPracticingPic = newVal
    },
    setIdCardPic(state, newVal) {
      state.idCardPic = newVal
    },
    setSignaturePic(state, newVal) {
      state.signaturePic = newVal
    },
    setDoctorQualificationPic(state, newVal) {
      state.doctorQualificationPic = newVal
    },
    setProfessionalQualificationPic(state, newVal) {
      state.professionalQualificationPic = newVal
    },
    setRegionInfo(state, newVal) {
      state.regionInfo = newVal
    },
    setHospitalInfo(state, newVal) {
      state.hospitalInfo = newVal
    },
    setBaseInfo(state, newVal) {
      state.baseInfo = newVal
    },
    setIsFirstVerify(state, newVal) {
      state.isFirstVerify = newVal
    },
    setAppUploadedImg(state, newVal) {
      state.appUploadedImg = { ...state.appUploadedImg, ...newVal }
    },
    setPageFrom(state, newVal) {
      state.pageFrom = newVal
    },
    setUserInfoForm(state, newVal) {
      state.userInfoForm = newVal
    }
  },
  actions: {}
}
